import type { FetchResponse, FetchError } from 'ofetch'
/**
 * Should be used only in scenarios where the API response is expected to be in a specific format when using $fetch
 */
export class APIResponse<TData> {
  success: boolean
  data: TData | undefined
  error?: string

  constructor() {
    this.success = false
    this.data = undefined
    this.error = ''
  }

  handleResponse(response: FetchResponse<TData>) {
    this.success = true
    this.data = response._data
  }

  handleError(response: FetchError<TData>) {
    this.success = false
    this.data = response.data
    this.error = response.statusMessage
  }

  getData() {
    return {
      success: this.success,
      data: this.data,
      error: this.error
    }
  }
}
